export const TASK_GET_TASKS_V2 = `
  query TaskGetTasksV2($req: GetTaskV2RequestInput) {
    taskGetTasksV2(req: $req) {
      responseCode
      responseMessage
      info {
        nextToken
        previousToken
        pageSize
        totalCount
        pageNumber
      }
      data {
        pk_task_id
        order_id
        user_type
        user_id
        task_description
        trans_type
        contact_number
        email_address
        customer_name
        delivery_date
        delivery_address
        team_id
        driver_id
        task_lat
        task_lng
        customer_signature
        status
        date_created
        date_modified
        ip_address
        auto_assign_type
        assign_started
        assignment_status
        dropoff_merchant
        dropoff_merchant_name
        dropoff_contact_name
        dropoff_contact_number
        drop_address
        dropoff_latitude
        dropoff_longitude
        recipient_name
        critical
        rating
        rating_comment
        rating_anonymous
        delivery_verification_code
        delivery_verified
        total_w_tax
        merchant_order_id
        merchant_order_status
        pickup_latitude
        pickup_longitude
        pickup_address
        taskDistance
        taskEstimatedTime
        driver_name
        driver_mobile
        shop_code
        assigned_limit_time
        current_time
       
        delivery_details {
          items {
            itemName
            itemType
            itemDescription
            width
            height
            length
            weight
          }
        }
      }
    }
  }
`;
